import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: '/',
    redirect: 'myHome',
  },
  {
    path: '/myHome',
    name: 'myHome',
    component: () => import('@/components/home.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
    },
  },
  {
    path: '/myHome/globalSearch',
    name: 'globalSearch',
    title: '首页-全局搜索',
    component: () => import('@/components/globalSearch/searchIndex.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
      // affix: true
    },
    hidden: true
  },
  {
    path: '/myHome/globalSearch/searchDetails',
    name: 'globalSearch/searchDetails',
    title:'首页-全局搜索详情',
    component: () => import('@/components/globalSearch/searchDetails.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
      // affix: true
    },
    hidden: true
  },

  {
    path: '/myHome/companyConsulting/newsDetails',
    name: 'myHome/companyConsulting/newsDetails',
    title: '新闻中心-新闻详情',
    component: () => import('@/components/newsDetails.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
      // affix: true
    },
    hidden: true,
  },

  {
    path: '/detailTempIndex/templateDetail',
    name: 'detailTempIndex/templateDetail',
    title: '通用详情',
    component: () => import('@/components/detailTempIndex/templateDetail.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
      // affix: true
    },
    hidden: true,
  },
  {
    path: '/detailTempIndex/templateDetailIndex',
    name: 'detailTempIndex/templateDetailIndex',
    title: '通用详情编辑',
    component: () =>
      import('@/components/detailTempIndex/templateDetailIndex.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
      // affix: true
    },
    hidden: true,
  },
  {
    path: '/aboutJingshu/partnerIndex',
    name: 'aboutJingshu/partnerIndex',
    title: '成为合作伙伴',
    component: () => import('@/components/aboutJingshu/partnerIndex.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
      // affix: true
    },
    hidden: true,
  },
  {
    path: '/aboutJingshu/recruitment',
    name: 'aboutJingshu/recruitment',
    title: '招贤纳士',
    component: () => import('@/components/aboutJingshu/recruitment.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
      // affix: true
    },
    hidden: true,
  },
  {
    path: '/aboutJingshu/recruitment/recruitmentList',
    name: 'aboutJingshu/recruitment/recruitmentList',
    title: '招贤纳士-岗位招聘',
    component: () => import('@/components/aboutJingshu/recruitmentList.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
      // affix: true
    },
    hidden: true,
  },
  {
    path: '/aboutJingshu/recruitment/recruitmentList/recruitmentDetails',
    name: 'aboutJingshu/recruitment/recruitmentList/recruitmentDetails',
    title: '招贤纳士-岗位招聘-详情',
    component: () => import('@/components/aboutJingshu/recruitmentDetails.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
      // affix: true
    },
    hidden: true,
  },

  {
    path: '/enterpriseHome',
    name: 'enterpriseHome',
    title: '企业服务',
    component: () =>
      import('@/components/enterpriseService/enterpriseHome.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
    },
    children: [],
  },
  {
    path: '/InquiryForm',
    name: 'InquiryForm',
    title: '企业服务-项目需求咨询',
    component: () => import('@/components/InquiryForm.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
    },
    children: [],
  },

  {
    path: '/enterpriseHome/enterpriseMobileSecurity',
    name: 'enterpriseHome/enterpriseMobileSecurity',
    title: '企业服务-企业安全移动通讯',
    component: () =>
      import('@/components/enterpriseService/enterpriseMobileSecurity.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
      // affix: true
    },
    hidden: true,
  },
  {
    path: '/enterpriseHome/enterpriseMobileSecurity/enterprisecublicCloud',
    name: 'enterpriseHome/enterpriseMobileSecurity/enterprisecublicCloud',
    title: '企业服务-企业安全移动通讯-公有云服务',
    component: () =>
      import('@/components/enterpriseService/enterprisecublicCloud.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
      // affix: true
    },
    hidden: true,
  },
  {
    path: '/enterpriseHome/enterpriseMobileSecurity/enterprisePrivateCloud',
    name: 'enterpriseHome/enterpriseMobileSecurity/enterprisePrivateCloud',
    title: '企业服务-企业安全移动通讯-私有云服务',
    component: () =>
      import('@/components/enterpriseService/enterprisePrivateCloud.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
      // affix: true
    },
    hidden: true,
  },
  {
    path: '/enterpriseHome/enterpriseMobileComm',
    name: 'enterpriseHome/enterpriseMobileComm',
    title: '企业服务-集团通讯',
    component: () =>
      import('@/components/enterpriseService/enterpriseMobileComm.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
      // affix: true
    },
    hidden: true,
  },
  {
    path: '/enterpriseHome/enterpriseMobileOffice',
    name: 'enterpriseHome/enterpriseMobileOffice',
    title: '企业服务-企业移动办公安全',
    component: () =>
      import('@/components/enterpriseService/enterpriseMobileOffice.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
      // affix: true
    },
    hidden: true,
  },
  {
    path: '/enterpriseHome/enterpriseSmartOffice',
    name: 'enterpriseHome/enterpriseSmartOffice',
    title: '企业服务-企业移动办公安全',
    component: () =>
      import('@/components/enterpriseService/enterpriseSmartOffice.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
      // affix: true
    },
    hidden: true,
  },
  {
    path: '/enterpriseHome/enterpriseEMM',
    name: 'enterpriseHome/enterpriseEMM',
    title: '企业服务-企业EMM管理系统',
    component: () => import('@/components/enterpriseService/enterpriseEMM.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
      // affix: true
    },
    hidden: true,
  },
  {
    path: '/enterpriseHome/enterprisePrivatizationOA',
    name: 'enterpriseHome/enterprisePrivatizationOA',
    title: '企业服务-企业私有化OA系统',
    component: () =>
      import('@/components/enterpriseService/enterprisePrivatizationOA.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
      // affix: true
    },
    hidden: true,
  },
  {
    path: '/enterpriseHome/enterpriseDataSecu',
    name: 'enterpriseHome/enterpriseDataSecu',
    title: '企业服务-数据安全定制',
    component: () =>
      import('@/components/enterpriseService/enterpriseDataSecu.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
      // affix: true
    },
    hidden: true,
  },
  {
    path: '/enterpriseHome/enterpriseDataSecu/enterpriseTransfer',
    name: 'enterpriseHome/enterpriseDataSecu/enterpriseTransfer',
    title: '企业服务-数据安全定制-安全传输',
    component: () =>
      import('@/components/enterpriseService/enterpriseTransfer.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
      // affix: true
    },
    hidden: true,
  },
  {
    path: '/enterpriseHome/enterpriseDataSecu/enterpriseStorage',
    name: 'enterpriseHome/enterpriseDataSecu/enterpriseStorage',
    title: '企业服务-数据安全定制-安全存储',
    component: () =>
      import('@/components/enterpriseService/enterpriseStorage.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
      // affix: true
    },
    hidden: true,
  },
  {
    path: '/enterpriseHome/enterpriseDataSecu/enterpriseConceal',
    name: 'enterpriseHome/enterpriseDataSecu/enterpriseConceal',
    title: '企业服务-数据安全定制-安全隐匿',
    component: () =>
      import('@/components/enterpriseService/enterpriseConceal.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
      // affix: true
    },
    hidden: true,
  },

  {
    path: '/enterpriseHome/enterpriseProcurement',
    name: 'enterpriseHome/enterpriseProcurement',
    title: '企业服务-企业采购方案',
    component: () =>
      import('@/components/enterpriseService/enterpriseProcurement.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
      // affix: true
    },
    hidden: true,
  },
  {
    path: '/enterpriseHome/enterpriseProcurement/enterpriseHardware',
    name: 'enterpriseHome/enterpriseProcurement/enterpriseHardware',
    title: '企业服务-企业采购方案-硬件采购',
    component: () =>
      import('@/components/enterpriseService/enterpriseHardware.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
      // affix: true
    },
    hidden: true,
  },
  {
    path: '/enterpriseHome/enterpriseProcurement/enterpriseSoftwarePurch',
    name: 'enterpriseHome/enterpriseProcurement/enterpriseSoftwarePurch',
    title: '企业服务-企业采购方案-软件采购',
    component: () =>
      import('@/components/enterpriseService/enterpriseSoftwarePurch.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
      // affix: true
    },
    hidden: true,
  },

  {
    path: '/goveHome',
    name: 'goveHome',
    title: '政务服务',
    component: () => import('@/components/governService/goveHome.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
    },
    hidden: true,
  },
  {
    path: '/goveHome/governmentalService',
    name: 'goveHome/governmentalService',
    title: '政务服务-硬件定制',
    component: () =>
      import('@/components/governService/governmentalService.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
    },
    hidden: true,
  },
  {
    path: '/goveHome/goveSoftware',
    name: 'goveHome/goveSoftware',
    title: '政务服务-软件定制',
    component: () => import('@/components/governService/goveSoftware.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
    },
    hidden: true,
  },
  {
    path: '/goveHome/goveSI',
    name: 'goveHome/goveSI',
    title: '政务服务-系统集成',
    component: () => import('@/components/governService/goveSI.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
    },
    hidden: true,
  },
  {
    path: '/goveHome/goveCommunication',
    name: 'goveHome/goveCommunication',
    title: '政务服务-安全通讯',
    component: () => import('@/components/governService/goveCommunication.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
    },
    hidden: true,
  },

  {
    path: '/goveHome/govePrivateComm',
    name: 'goveHome/govePrivateComm',
    title: '政务服务-私有通讯',
    component: () => import('@/components/governService/govePrivateComm.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
    },
    hidden: true,
  },

  {
    path: '/goveHome/goveEmm',
    name: 'goveHome/goveEmm',
    title: '政务服务-政府EMM管理系统',
    component: () => import('@/components/governService/goveEmm.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
    },
    hidden: true,
  },

  {
    path: '/customizeHome',
    name: 'customizeHome',
    title: '定制服务',
    component: () => import('@/components/customizeService/customizeHome.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
    },
    hidden: true,
  },
  {
    path: '/customizeHome/customizeEnterprise',
    name: 'customizeHome/customizeEnterprise',
    title:'企业定制服务',
    component: () => import('@/components/customizeService/customizeEnterprise.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
    },
    hidden: true
  },
  {
    path: '/customizeHome/customizeQydz',
    name: 'customizeHome/customizeQydz',
    title:'企业定制服务',
    component: () => import('@/components/customizeService/customizeQydz.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
    },
    hidden: true,
  },
  {
    path: '/customizeHome/customizePrivate',
    name: 'customizeHome/customizePrivate',
    title: '私人定制服务',
    component: () =>
      import('@/components/customizeService/customizePrivate.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
    },
    hidden: true,
  },
  {
    path: '/systemProduct/vargoAppStore',
    name: 'systemProduct/vargoAppStore',
    title: '应用下载',
    component: () => import('@/components/software/vargoAppStore.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
    },
    hidden: true,
  },

  {
    path: '/systemProduct',
    name: 'systemProduct',
    title: '软件产品',
    component: () => import('@/components/systemProduct.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
    },
    hidden: true,
  },

  {
    path: '/systemProduct/systemEMMdevice',
    name: 'systemProduct/systemEMMdevice',
    title: '软件产品-EMM设备数据智能管理系统',
    component: () => import('@/components/systemEMMdevice.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
    },
    hidden: true,
  },

  {
    path: '/productHome',
    name: 'productHome',
    title: '产品',
    component: () => import('@/components/software/productHome.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
    },
    hidden: true,
  },

  {
    path: '/deviceManagement',
    name: 'deviceManagement',
    title: '设备管理',
    component: () => import('@/views/mobile/software/deviceManagement.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
    },
    hidden: true,
  },
  {
    path: '/cloudSecurity',
    name: 'cloudSecurity',
    title: '设备管理',
    component: () => import('@/views/mobile/software/cloudSecurity.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
    },
    hidden: true,
  },
  {
    path: '/productHome/productEmm',
    name: 'productHome/productEmm',
    title: '产品-EMM设备数据智能管理系统',
    component: () => import('@/components/software/productEmm.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
    },
    hidden: true,
  },
  {
    path: '/productHome/kyosuyun',
    name: 'productHome/kyosuyun',
    title: '产品-企业移动办公系统-京数云系统',
    component: () => import('@/components/software/kyosuyun.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
    },
    hidden: true,
  },
  {
    path: '/productHome/productMobileOffice',
    name: 'productHome/productMobileOffice',
    title: '产品-企业移动办公系统',
    component: () => import('@/components/software/productMobileOffice.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
    },
    hidden: true,
  },
  {
    path: '/productHome/productMobileOffice/mobileTerminal',
    name: 'productHome/productMobileOffice/mobileTerminal',
    title: '产品-企业移动办公系统-移动终端安全工作系统',
    component: () => import('@/components/software/mobileTerminal.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
    },
    hidden: true,
  },
  {
    path: '/productHome/productMobileOffice/securityControl',
    name: 'productHome/productMobileOffice/securityControl',
    title: '产品-企业移动办公系统-移动安全管控',
    component: () => import('@/components/software/securityControl.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
    },
    hidden: true,
  },
  {
    path: '/productHome/productMobileOffice/securityPolicy',
    name: 'productHome/productMobileOffice/securityPolicy',
    title: '产品-企业移动办公系统-移动业务场景安全策略平台',
    component: () => import('@/components/software/securityPolicy.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
    },
    hidden: true,
  },

  {
    path: '/systemProduct/systemCloud',
    name: 'systemProduct/systemCloud',
    title: '软件产品-京数云系统',
    component: () => import('@/components/systemCloud.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
    },
    hidden: true,
  },

  {
    path: '/serviceHome',
    name: 'serviceHome',
    title: '服务',
    component: () => import('@/components/serviceHome.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
    },
    hidden: true,
  },
  {
    path: '/serviceHome/afterSalesService',
    name: 'serviceHome/afterSalesService',
    title: '售后服务',
    component: () => import('@/components/serveButHome/afterSalesService.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
    },
    hidden: true,
  },

  // {
  //   path: '/serveButHome/afterSalesService/serveRepair',
  //   name: 'serveButHome/afterSalesService/serveRepair',
  //   title:'售后服务-在线报修',
  //   component: () => import('@/components/serveButHome/serveRepair.vue'),
  //   meta: {
  //     title: '京数科技（上海）有限公司',
  //     icon: '',
  //   },
  //   hidden: true
  // },
  {
    path: '/serveButHome/onlineRepairs',
    name: 'serveButHome/onlineRepairs',
    title: '售后服务-在线报修',
    component: () =>
      import('@/components/serveButHome/onlineHome/onlineRepairs.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
    },
    hidden: true,
  },
  // 正在建设中
  {
    path: '/serveButHome/onlineHome/tempIndex',
    name: 'serveButHome/onlineHome/tempIndex',
    title: '售后服务-在线报修-在线报修',
    component: () =>
      import('@/components/serveButHome/onlineHome/tempIndex.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
    },
    hidden: true,
  },
  {
    path: '/serveButHome/onlineHome/onlineForm',
    name: 'serveButHome/onlineHome/onlineForm',
    title: '售后服务-在线报修',
    component: () =>
      import('@/components/serveButHome/onlineHome/onlineForm.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
    },
    hidden: true,
  },
  {
    path: '/serveButHome/onlineHome/repairInquiry',
    name: 'serveButHome/onlineHome/repairInquiry',
    title: '售后服务-在线报修-报修查询',
    component: () =>
      import('@/components/serveButHome/onlineHome/repairInquiry.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
    },
    hidden: true,
  },
  {
    path: '/serveButHome/onlineHome/afterSales',
    name: 'serveButHome/onlineHome/afterSales',
    title: '售后服务-在线报修-手机/电脑',
    component: () =>
      import('@/components/serveButHome/onlineHome/afterSales.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
    },
    hidden: true,
  },
  {
    path: '/serveButHome/onlineHome/repairSales',
    name: 'serveButHome/onlineHome/repairSales',
    title: '售后服务-在线报修-返修退货处理',
    component: () =>
      import('@/components/serveButHome/onlineHome/repairSales.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
    },
    hidden: true,
  },

  {
    path: '/serveButHome/serveWarranty',
    name: 'serveButHome/serveWarranty',
    title: '售后服务-售后查询',
    component: () => import('@/components/serveButHome/serveWarranty.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
    },
    hidden: true,
  },

  {
    path: '/serveButHome/accessoryInquiry',
    name: 'serveButHome/accessoryInquiry',
    title: '售后服务-配件查询',
    component: () => import('@/components/serveButHome/accessoryInquiry.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
    },
    hidden: true,
  },
  {
    path: '/serveButHome/networkQuery',
    name: 'serveButHome/networkQuery',
    title: '售后服务-网点查询',
    component: () => import('@/components/serveButHome/networkQuery.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
    },
    hidden: true,
  },

  {
    path: '/serveButHome/driverDownload',
    name: 'serveButHome/driverDownload',
    title: '售后服务-驱动下载',
    component: () => import('@/components/serveButHome/driverDownload.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
    },
    hidden: true,
  },

  {
    path: '/serveButHome/applicationStore',
    name: 'serveButHome/applicationStore',
    title: '应用下载',
    component: () =>
      import('@/components/serveButHome/applicationHome/applicationStore.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
    },
    hidden: true,
  },
  {
    path: '/serveButHome/applicationStore/appShop',
    name: 'serveButHome/applicationStore/appShop',
    title: '应用下载-应用商店',
    component: () =>
      import('@/components/serveButHome/applicationHome/appShop.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
    },
    hidden: true,
  },
  {
    path: '/serveButHome/applicationStore/appVtime',
    name: 'serveButHome/applicationStore/appVtime',
    title: '应用下载-Vtime',
    component: () =>
      import('@/components/serveButHome/applicationHome/appVtime.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
    },
    hidden: true,
  },
  {
    path: '/serveButHome/applicationStore/appNFC',
    name: 'serveButHome/applicationStore/appNFC',
    title: '应用下载-NFC',
    component: () =>
      import('@/components/serveButHome/applicationHome/appNFC.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
    },
    hidden: true,
  },

  {
    path: '/serveButHome/applicationStore/secureTransmission',
    name: 'serveButHome/applicationStore/secureTransmission',
    title: '应用下载-安全传输',
    component: () =>
      import(
        '@/components/serveButHome/applicationHome/secureTransmission.vue'
      ),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
    },
    hidden: true,
  },

  {
    path: '/serveButHome/applicationStore/secureTelephone',
    name: 'serveButHome/applicationStore/secureTelephone',
    title: '应用下载-安全电话',
    component: () =>
      import('@/components/serveButHome/applicationHome/secureTelephone.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
    },
    hidden: true,
  },
  {
    path: '/serveButHome/applicationStore/secureSMS',
    name: 'serveButHome/applicationStore/secureSMS',
    title: '应用下载-安全短信',
    component: () =>
      import('@/components/serveButHome/applicationHome/secureSMS.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
    },
    hidden: true,
  },

  {
    path: '/aboutUs',
    name: 'aboutUs',
    title: '关于我们',
    component: () => import('@/components/aboutUs.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
    },
    hidden: true,
  },
  {
    path: '/myHome/companyConsulting',
    name: 'myHome/companyConsulting',
    title: '关于京数-公司资讯',
    component: () => import('@/components/companyConsulting.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
    },
    hidden: true,
  },
  {
    path: '/aboutUs/teamDetails',
    name: 'aboutUs/teamDetails',
    title: '关于京数-团队介绍',
    component: () => import('@/components/teamDetails.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
    },
    hidden: true,
  },
  {
    path: '/aboutUs/corporateWelfare',
    name: 'aboutUs/corporateWelfare',
    title: '关于京数-企业福利',
    component: () => import('@/components/corporateWelfare.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
    },
    hidden: true,
  },

  {
    path: '/aboutUs/companyIntro',
    name: 'aboutUs/companyIntro',
    title: '公司简介',
    component: () => import('@/components/companyIntro.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
    },
    hidden: true,
  },

  {
    path: '/static/products',
    name: 'static/products',
    title: '产品',
    component: () => import('@/views/staticPages/products.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
    },
    hidden: true,
  },

  {
    path: '/static/solutions',
    name: 'static/solutions',
    title: '解决方案',
    component: () => import('@/views/staticPages/solutions.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
    },
    hidden: true,
  },

  {
    path: '/static/abilities',
    name: 'static/abilities',
    title: '核心能力',
    component: () => import('@/views/staticPages/abilities.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
    },
    hidden: true,
  },

  {
    path: '/static/companyService',
    name: 'static/companyService',
    title: '核心能力',
    component: () => import('@/views/staticPages/companyService.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
    },
    hidden: true,
  },

  {
    path: '/static/detail/:id',
    name: 'static/detail',
    title: '核心能力',
    component: () => import('@/views/staticPages/detail.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
    },
    hidden: true,
  },
  // {
  //   path: '/talentsScheme',
  //   name: 'talentsScheme',
  //   title:'人才计划',
  //   component: () => import('@/components/talentsScheme.vue'),
  //   meta: {
  //     title: '京数科技（上海）有限公司',
  //     icon: '',
  //   },
  //   hidden: true
  // },

  {
    path: '/talentsScheme',
    name: 'talentsScheme',
    title: '企业福利',
    component: () => import('@/components/talentsScheme.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
      icon: '',
    },
    hidden: true,
  },

  {
    path: '/home-page',
    name: 'HomePage',
    component: () => import('@/views/home-page/index.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
    },
  },
  {
    path: '/test',
    name: 'test',
    component: () => import('@/views/testsf/index.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
    },
  },
  {
    path: '/index',
    name: 'index',
    component: () => import('@/views/index/index.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
    },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/page/login.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
    },
  },
  {
    path: '/bikeReg',
    title: '注册',
    name: 'bikeReg',
    component: () => import('@/views/page/bikeReg.vue'),
    meta: {
      title: '京数科技（上海）有限公司',
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

let originPush = VueRouter.prototype.push; //备份原push方法

VueRouter.prototype.push = function (location, resolve, reject) {
  if (resolve && reject) {
    //如果传了回调函数，直接使用
    originPush.call(this, location, resolve, reject);
  } else {
    if (location.name && location.name.startsWith('/static')) {
      originPush.call(
        this,
        {...location,
          name: null,
          path: location.name
        },
        () => {},
        () => {}
      );
    } else {
      //如果没有传回调函数，手动添加
      originPush.call(
        this,
        location,
        () => {},
        () => {}
      );
    }
  }
};

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0);
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

export default router;
